import { createUseStyles } from "react-jss";
import {
  cardGrid,
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

const useStyles = createUseStyles((_) => ({
  contentMain: pageShellRoot,

  vehiculeRoot: pageContentRoot,

  container: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    minWidth: 0,
  },

  /* Dropped `maxWidth: 1315` — it capped only the header, so on a wide
     monitor the title row stopped short while the cards below ran on to the
     edge of the screen. */
  containerHeader: pageHeaderRow,

  containerBody: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
  },

  /* A fixed `flex-direction: row` with `flex: 1` children compressed the KPI
     cards until their numbers overlapped their labels on a tablet. An
     auto-fit grid keeps each card at a readable width and wraps instead. */
  containerCarsInfos: cardGrid(240),

  divScroll: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
    padding: "3px",
  },
}));

export default useStyles;
